// For full API documentation, including code examples, visit https://wix.to/94BuAAs



$w.onReady(function () {
	//TODO: write your page related code here...
<meta name="google-site-verification" content="pVl9G_sWeYZP0nlfGOHxSq-dC0dN4aVKB2S-R6N-jYo" />
});